import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';
import BrokersLandingView from '@/website/components/NewLandingPages/brokers/index';
import HeadMetaView, { HeadMetaTypeEnum } from '@/website/components/headMetas/common';
import Layout from '@/website/layouts/newLandingPages';
import { ContentfulPageProps, getContentfulData } from '@/website/lib/getContentfulData';
import { Box } from '@mui/material';

const SLUG = 'broker-landing';
export async function getServerSideProps(context: GetServerSidePropsContext): Promise<GetServerSidePropsResult<ContentfulPageProps>> {
  return getContentfulData(context, SLUG, {
    metaInfo: {
      description:
        'Jove is an MGA backed by Accelerant, offering brokers a white-label portal and customer interface. Access our commercial combined scheme for global businesses up to £100m turnover across 250+ occupations.',
      images: '/broker-landing.png',
    },
    useNewLogic: true,
    dataFileName: 'broker-landing.json',
  });
}

const BrokerLandingPage = (props: ContentfulPageProps) => {
  const { post, metadata } = props;

  return (
    <Layout.Wrapper>
      <HeadMetaView metaType={HeadMetaTypeEnum.brokerLanding} info={metadata?.openGraph} />
      <Layout.Header />
      <Layout.Content>
        <Box
          className="flex flex-col space-y-16"
          style={{
            background: 'linear-gradient(180deg, #EBEFFE 0%, rgba(235, 239, 254, 0.00) 53.37%, #EBEFFE 100%',
          }}
        >
          <BrokersLandingView info={post} />
        </Box>
      </Layout.Content>
      <Layout.Footer />
    </Layout.Wrapper>
  );
};

export default BrokerLandingPage;
